<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Outpatient Services (for international patients with or without Korean National Health Insuarance)</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">STEP 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Make an appointment</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Visit the international Healthcare Center</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Consult with your physician</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 04</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Complete payment</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 05</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Proceed with test and prescription pick up</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">Make an appointment</h4>
            <p class="depth">
                Call us at +82-6986-3100 <br>
                E-mail via eumcint@gmail.com <br>
                Apply online at Request an appointment <br>
                Visit our clinic(Please note that the same day appointment may not be possible.)
            </p>
            <h4 class="depth bullet02">Visit the international Healthcare Center</h4>
            <p class="depth">
                Visit the International Healthcare Center on the 1st floor. You are required to bring your ARC or passport for patient registration. If you have medical records, test results, or CD images, please arrive 10 minutes earlier to register the material. You can visit your assigned physician with your hospital identification number.
            </p>
            <h4 class="depth bullet02">Consult with your physician</h4>
            <p class="depth">
                The physician will discuss your care plan and recommend you to other specialist should it be necessary. International Healthcare Center nurse or coordinator will assist you when scheduling diagnostic test or follow-up appointment
            </p>
            <h4 class="depth bullet02">Complete payment</h4>
            <p class="depth">
                Treatment fees can be paid with cash (Korean Won) or credit card. If you require foreign exchange services the bank on the B1 of the main building can provide assistance. As per ouf hospital policy all outpatient examinations, treatments other than consultation should be paid prior to the appointment. Please bring international insurance forms with you (should you require to submit them back to your insurance company).
            </p>
            <h4 class="depth bullet02">Proceed with test and prescription pick up</h4>
            <p class="depth">
                Once all payments are competed you can complete with your scheduled tests as required. Please print your prescription and proceed to the pharmacy for pickup.
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>